import React, { useState } from 'react';
import { Card, CardBody } from "reactstrap";
import { ListSessionsCardSelect } from '../../../../globals/core/ListSessionsCardSelect/ListSessionsCardSelect';
import styles from "./index.module.scss";
import UserListInEntity from '../../../users/UserListInEntity';
import { CardSelect } from '../../../../globals/core/CardSelect/CardSelect';
import { searchRelatedAction } from '../../../content/Content';

interface EventNavbarProps {
    formState: any;
    backData: any;
    forceUpdate: () => void;
    setFormState: (formState: any) => void;
    setItemChange: (isItemChanged: boolean) => void
}

const EventNavbar = ({ formState, forceUpdate, setFormState, setItemChange }: EventNavbarProps) => {
    const { relatedSessions, participants, _id, related } = formState;

    const [activeTab, setActiveTab] = useState('Sessions');
    const tabs = ['Sessions', 'Library', 'Users'];

    const isSessionsActive = activeTab === 'Sessions';
    const isLibraryActive = activeTab === 'Library';
    const isUsersActive = activeTab === 'Users';

    const handleStateChange = (name: string, updatedState: any, itemChange = false) => {
        setFormState((prevState: any) => ({
            ...prevState,
            [name]: updatedState
        }));
        itemChange && setItemChange(true);
    };

    return (
        <Card className={styles.container} style={{ borderRadius: "20px" }}>
            <CardBody>
                <div className={styles.title}>Event management</div>
                <nav className={styles.tabs}>
                    {tabs.map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`${styles.tab} ${activeTab === tab ? styles.active : ''}`}
                        >
                            {tab}
                        </button>
                    ))}
                </nav>

                <div className={styles.item}>
                    {isSessionsActive &&
                        <ListSessionsCardSelect
                            cards={relatedSessions}
                            setCards={(updatedCards: any) => handleStateChange("relatedSessions", updatedCards)}
                        />
                    }

                    {isLibraryActive &&
                        <CardSelect placeholder="Search for Content Items"
                            cards={related}
                            setCards={(updatedCards: any) => handleStateChange("related", updatedCards, true)}
                            searchAction={searchRelatedAction}
                        />
                    }
                    {isUsersActive &&
                        <UserListInEntity
                            cards={participants}
                            entity={_id}
                            entityType={"seminar"}
                            forceUpdate={forceUpdate}
                        />
                    }
                </div>
            </CardBody>
        </Card>

    );
};

export default EventNavbar;